import { PlusInSquareIcon } from "assets/icons";
import classNames from "classnames";
import { If, TabLink } from "components";
import { useBoolean } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "ui";

import { DeliveryFeeModal } from "../../components";
import { DeliveryFeeListItem } from "../../financial.types";
import { FeesTabContent, LocationsTabContent } from "./atoms";

import styles from "./DeliveryFees.module.scss";

const DeliveryFees = () => {
  const { t } = useTranslation();

  const { activeTab } = useParams();

  const {
    value: isFeeModalOpen,
    setTrue: openFeeAddModal,
    setFalse: closeFeeAddModal
  } = useBoolean(false);

  const [editableFee, setEditableFee] = useState<DeliveryFeeListItem | null>(
    null
  );

  const handleCloseFeeModal = () => {
    closeFeeAddModal();
    setEditableFee(null);
  };

  const onEditFeePress = (itemForEdit: DeliveryFeeListItem) => {
    setEditableFee(itemForEdit);
    openFeeAddModal();
  };

  return (
    <ContentLayout
      title={t("Delivery Fees")}
      action={
        <Button onClick={openFeeAddModal} icon={<PlusInSquareIcon />}>
          {t("Add Delivery Zone")}
        </Button>
      }
    >
      <BoxShadowLayout
        className={classNames({
          [styles.feesPageContent]: activeTab === "fees"
        })}
      >
        <div className={styles.pageContent_tabs}>
          <TabLink label="Fees" pathName="/delivery-fees/fees" />
          <TabLink label="Locations" pathName="/delivery-fees/locations" />
        </div>

        <If condition={activeTab === "fees"}>
          <FeesTabContent onEditFeePress={onEditFeePress} />
        </If>
      </BoxShadowLayout>

      <If condition={activeTab === "locations"}>
        <LocationsTabContent />
      </If>

      <If condition={isFeeModalOpen}>
        <DeliveryFeeModal
          isOpen={isFeeModalOpen}
          onClose={handleCloseFeeModal}
          editableFee={editableFee}
        />
      </If>
    </ContentLayout>
  );
};

export default DeliveryFees;
